import React from 'react';

const Footer = () => (
    <footer className="site-footer">
        <div className="text-muted text-center">&copy; {new Date().getFullYear()} TwoReporters.com. All Rights Reserved.</div>
    </footer>
);

export default Footer;